exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmation-icon-inline {\n    display: inline-block;\n}\n\n.confirmation-title {\n    line-height: 24px;\n    color: #000000;\n    font-size: 22px;\n}\n\n.confirmation-content {\n    font-size: 14px;\n    color: #565656;\n    line-height: 24px;\n    display: inline-block;\n    vertical-align: middle;\n    width: 80%;\n    white-space: pre-wrap;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/confirmation-dialog/confirmation-dialog.component.css
// module id = 831
// module chunks = 0